module.exports = __webpack_public_path__ + "media/images/ui__arrowDown-fc62880e6c8be9816542626988f1cad9.png";